import { render, staticRenderFns } from "./App.vue?vue&type=template&id=12f55c12&scoped=true&"
import script from "./App.vue?vue&type=script&lang=ts&"
export * from "./App.vue?vue&type=script&lang=ts&"
import style0 from "@tencent/tigui/scss/reset/reset_m.scss?vue&type=style&index=0&lang=scss&"
import style1 from "scss/global/layout/layout.scss?vue&type=style&index=1&lang=scss&"
import style2 from "assets/css/common/landscape.css?vue&type=style&index=2&id=12f55c12&scoped=true&lang=css&"
import style3 from "assets/scss/game-operation/2020/index.scss?vue&type=style&index=3&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f55c12",
  null
  
)

export default component.exports